(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ln-welcome"]) return;
  try {
    
if (!customElements.get('ln-editable-popup')) {
 customElements.define('ln-editable-popup',class extends HTMLElement {
  connectedCallback() {
   this.popup=this.querySelector('dialog');
   if(!this.popup)return;
   this.abort=new AbortController();
   const options={signal:this.abort.signal};
   const editor=this.dataset.editor==='true';
   const key='ln-offer-'+this.dataset.code;
   const close=()=>this.popup.close();
   this.querySelector('.ln-close').addEventListener('click',close,options);
   this.querySelector('.ln-cta').addEventListener('click',event=>{if(editor)event.preventDefault();else close();},options);
   this.popup.addEventListener('close',()=>{if(this.previous?.isConnected)this.previous.focus();},options);
   this.popup.addEventListener('click',event=>{if(event.target===this.popup){const r=this.popup.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();}},options);
   const show=()=> {
    if(!this.isConnected||this.popup.open)return;
    if(editor){this.popup.show();return;}
    const force=new URLSearchParams(location.search).get('ln_popup')==='1';
    try {
     if(!force&&this.dataset.frequency==='session'&&sessionStorage.getItem(key))return;
     if(!force&&this.dataset.frequency==='week'&&Date.now()-Number(localStorage.getItem(key))<604800000)return;
    }catch(e){}
    if(document.querySelector('dialog[open]'))return;
    this.previous=document.activeElement;this.popup.showModal();
    try{if(this.dataset.frequency==='session')sessionStorage.setItem(key,'1');if(this.dataset.frequency==='week')localStorage.setItem(key,String(Date.now()));}catch(e){}
   };
   if(editor){show();document.addEventListener('shopify:section:select',event=>{if(event.target.contains(this))show();},options);}
   else {const schedule=()=>{this.timer=setTimeout(show,Number(this.dataset.delay)||0);};if(document.readyState==='complete')schedule();else window.addEventListener('load',schedule,{once:true,signal:this.abort.signal});}
  }
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();if(this.popup?.open)this.popup.close();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-la-natural"] && !Shopify.designMode) return;
  try {
    
function openNaturalReviews(scroll) {
  const section = document.getElementById('ln-testimonials');
  if (!section) return;
  const accordion = section.querySelector('.ln-testimonials__accordion');
  if (!accordion) return;
  accordion.open = true;
  if (scroll) {
    const summary = accordion.querySelector('summary');
    summary.focus({ preventScroll: true });
    section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  }
}
document.addEventListener('click', function(event) {
  const link = event.target.closest('[data-ln-reviews-link]');
  if (!link || !document.getElementById('ln-testimonials')) return;
  event.preventDefault();
  openNaturalReviews(true);
});
if (window.location.hash === '#ln-testimonials') openNaturalReviews(true);

  } catch(e) { console.error(e); }
})();
})();
